import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_INV_REP_025 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  //#endregion

  //#region Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const { userInfo } = global();
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      searchDataToUse.dt_from = searchDataToUse.dt_from.slice(0, 6);
      const param = {
        id: "sn_mtl_inv_rep_025_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSources({
        grid1: data[0],
      });
    } catch (error) {}
  };
  //#endregion

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]}
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            isEditable: false,
          }}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_INV_REP_025;
